import * as THREE from 'three';
import { RoomEnvironment } from './roomEnvironment.js';

class b {
    #e;
    canvas;
    camera;
    cameraMinAspect;
    cameraMaxAspect;
    cameraFov;
    maxPixelRatio;
    minPixelRatio;
    scene;
    renderer;
    #t;
    size = { width: 0, height: 0, wWidth: 0, wHeight: 0, ratio: 0, pixelRatio: 0 };
    render = this.#i;
    onBeforeRender = () => { };
    onAfterRender = () => { };
    onAfterResize = () => { };
    #s = false;
    #n = false;
    isDisposed = false;
    #o;
    #r;
    #a;
    #c = new THREE.Clock();
    #h = { elapsed: 0, delta: 0 };
    #l;
    constructor(e) {
        this.#e = { ...e };
        this.#m();
        this.#d();
        this.#p();
        this.resize();
        this.#g();
    }
    #m() {
        this.camera = new THREE.PerspectiveCamera();
        this.cameraFov = this.camera.fov;
    }
    #d() {
        this.scene = new THREE.Scene();
    }
    #p() {
        if (this.#e.canvas) {
            this.canvas = this.#e.canvas;
        } else if (this.#e.id) {
            this.canvas = document.getElementById(this.#e.id);
        } else {
            console.error("Three: Missing canvas or id parameter");
        }
        this.canvas.style.display = "block";
        const e = {
            canvas: this.canvas,
            powerPreference: "default",
            ...this.#e.rendererOptions?? {}
        };
        this.renderer = new THREE.WebGLRenderer(e);
        this.renderer.outputColorSpace = THREE.SRGBColorSpace;
    }
    #g() {
        if (!(this.#e.size instanceof Object)) {
            window.addEventListener("resize", this.#f.bind(this));
            if (this.#e.size === "parent") {
                this.#r = new ResizeObserver(this.#f.bind(this));
                this.#r.observe(this.canvas.parentNode);
            }
        }
        this.#o = new IntersectionObserver(this.#u.bind(this), {
            root: null,
            rootMargin: "0px",
            threshold: 0
        });
        this.#o.observe(this.canvas);
        document.addEventListener("visibilitychange", this.#v.bind(this));
    }
    #y() {
        window.removeEventListener("resize", this.#f.bind(this));
        this.#r?.disconnect();
        this.#o?.disconnect();
        document.removeEventListener("visibilitychange", this.#v.bind(this));
    }
    #u(e) {
        this.#s = e[0].isIntersecting;
        this.#s? this.#w() : this.#z();
    }
    #v(e) {
        if (this.#s) {
            document.hidden? this.#z() : this.#w();
        }
    }
    #f() {
        if (this.#a) {
            clearTimeout(this.#a);
        }
        this.#a = setTimeout(this.resize.bind(this), 100);
    }
    resize() {
        let e, t;
        if (this.#e.size instanceof Object) {
            e = this.#e.size.width;
            t = this.#e.size.height;
        } else if (this.#e.size === "parent" && this.canvas.parentNode) {
            e = this.canvas.parentNode.offsetWidth;
            t = this.canvas.parentNode.offsetHeight;
        } else {
            e = window.innerWidth;
            t = window.innerHeight;
        }
        this.size.width = e;
        this.size.height = t;
        this.size.ratio = e / t;
        this.#R();
        this.#b();
        this.onAfterResize(this.size);
    }
    #R() {
        this.camera.aspect = this.size.width / this.size.height;
        if (this.camera.isPerspectiveCamera && this.cameraFov) {
            if (this.cameraMinAspect && this.camera.aspect < this.cameraMinAspect) {
                this.#A(this.cameraMinAspect);
            } else if (this.cameraMaxAspect && this.camera.aspect > this.cameraMaxAspect) {
                this.#A(this.cameraMaxAspect);
            } else {
                this.camera.fov = this.cameraFov;
            }
        }
        this.camera.updateProjectionMatrix();
        this.updateWorldSize();
    }
    #A(e) {
        const t = Math.tan(THREE.MathUtils.degToRad(this.cameraFov / 2)) / (this.camera.aspect / e);
        this.camera.fov = 2 * THREE.MathUtils.radToDeg(Math.atan(t));
    }
    updateWorldSize() {
        if (this.camera.isPerspectiveCamera) {
            const e = this.camera.fov * Math.PI / 180;
            this.size.wHeight = 2 * Math.tan(e / 2) * this.camera.position.length();
            this.size.wWidth = this.size.wHeight * this.camera.aspect;
        } else if (this.camera.isOrthographicCamera) {
            this.size.wHeight = this.camera.top - this.camera.bottom;
            this.size.wWidth = this.camera.right - this.camera.left;
        }
    }
    #b() {
        this.renderer.setSize(this.size.width, this.size.height);
        this.#t?.setSize(this.size.width, this.size.height);
        let e = window.devicePixelRatio;
        if (this.maxPixelRatio && e > this.maxPixelRatio) {
            e = this.maxPixelRatio;
        } else if (this.minPixelRatio && e < this.minPixelRatio) {
            e = this.minPixelRatio;
        }
        this.renderer.setPixelRatio(e);
        this.size.pixelRatio = e;
    }
    get postprocessing() {
        return this.#t;
    }
    set postprocessing(e) {
        this.#t = e;
    }
    #w() {
        if (this.#n) return;
        const e = () => {
            this.#l = requestAnimationFrame(e);
            this.#h.delta = this.#c.getDelta();
            this.#h.elapsed += this.#h.delta;
            this.onBeforeRender(this.#h);
            this.render();
            this.onAfterRender(this.#h);
        };
        this.#n = true;
        this.#c.start();
        e();
    }
    #z() {
        if (this.#n) {
            cancelAnimationFrame(this.#l);
            this.#n = false;
            this.#c.stop();
        }
    }
    #i() {
        this.renderer.render(this.scene, this.camera);
    }
    clear() {
        this.scene.traverse((e) => {
            if (e.isMesh && typeof e.material === "object") {
                Object.keys(e.material).forEach((t) => {
                    const i = e.material[t];
                    if (i!== null && typeof i === "object" && typeof i.dispose === "function") {
                        i.dispose();
                    }
                });
                e.material.dispose();
                e.geometry.dispose();
            }
        });
        this.scene.clear();
    }
    dispose() {
        this.#y();
        this.#z();
        this.clear();
        this.renderer.dispose();
        this.isDisposed = true;
    }
}

const A = new Map();
const x = new THREE.Vector2();
let L = false;

function M(e) {
    const t = {
        position: new THREE.Vector2(),
        nPosition: new THREE.Vector2(),
        hover: false,
        onEnter() { },
        onMove() { },
        onClick() { },
        onLeave() { },
        ...e
    };
    function bindEvents(e, t) {
        if (!A.has(e)) {
            A.set(e, t);
            if (!L) {
                document.body.addEventListener("pointermove", S);
                document.body.addEventListener("pointerleave", P);
                document.body.addEventListener("click", C);
                L = true;
            }
        }
    }
    bindEvents(e.domElement, t);
    t.dispose = () => {
        let element = e.domElement;
        A.delete(element);
        if (A.size === 0) {
            document.body.removeEventListener("pointermove", S);
            document.body.removeEventListener("pointerleave", P);
            L = false;
        }
    };
    return t;
}

function S(e) {
    x.x = e.clientX;
    x.y = e.clientY;
    for (const [e, t] of A) {
        const i = e.getBoundingClientRect();
        if (k(i)) {
            D(t, i);
            if (!t.hover) {
                t.hover = true;
                t.onEnter(t);
            }
            t.onMove(t);
        } else if (t.hover) {
            t.hover = false;
            t.onLeave(t);
        }
    }
}

function C(e) {
    x.x = e.clientX;
    x.y = e.clientY;
    for (const [e, t] of A) {
        const i = e.getBoundingClientRect();
        D(t, i);
        if (k(i)) {
            t.onClick(t);
        }
    }
}

function P() {
    for (const e of A.values()) {
        if (e.hover) {
            e.hover = false;
            // 记录离开时的位置
            const o = e.domElement.dataset.target;
            if (o) {
                const target = document.getElementById(o);
                if (target) {
                    const rect = target.getBoundingClientRect();
                    e.onLeave({
                        ...e,
                        leaveX: rect.left,
                        leaveY: rect.top
                    });
                }
            } else {
                e.onLeave(e);
            }
        }
    }
}


function D(e, t) {
    const { position: i, nPosition: s } = e;
    i.x = x.x - t.left;
    i.y = x.y - t.top;
    s.x = i.x / t.width * 2 - 1;
    s.y = -i.y / t.height * 2 + 1;
}

function k(e) {
    const { x: t, y: i } = x;
    const { left: s, top: n, width: o, height: r } = e;
    return t >= s && t <= s + o && i >= n && i <= n + r;
}

const { randFloat: E, randFloatSpread: I } = THREE.MathUtils;
const F = new THREE.Vector3();
const O = new THREE.Vector3();
const V = new THREE.Vector3();
const N = new THREE.Vector3();
const j = new THREE.Vector3();
const _ = new THREE.Vector3();
const W = new THREE.Vector3();
const H = new THREE.Vector3();
const T = new THREE.Vector3();

class B {
    constructor(e) {
        this.config = e;
        this.positionData = new Float32Array(3 * e.count).fill(0);
        this.velocityData = new Float32Array(3 * e.count).fill(0);
        this.sizeData = new Float32Array(e.count).fill(1);
        this.center = new THREE.Vector3();
        this.randomPositions();
    }
    randomPositions() {
        const { config: e, positionData: t, sizeData: i } = this;
        this.center.toArray(t, 0);
        i[0] = e.size0;
        for (let s = 1; s < this.config.count; s++) {
            const n = 3 * s;
            t[n] = I(10);
            t[n + 1] = I(10);
            t[n + 2] = I(10);
            i[s] = E(e.minSize, e.maxSize);
        }
    }
    update(e) {
        const { config: t, center: i, positionData: s, sizeData: n, velocityData: o } = this;
        F.fromArray(s, 0);
        F.lerp(i, 0.1).toArray(s, 0);
        for (let i = 1; i < this.config.count; i++) {
            const r = 3 * i;
            O.fromArray(s, r);
            N.fromArray(o, r);
            const a = n[i];
            _.copy(F).sub(O);
            N.add(_.normalize().multiplyScalar(e.delta * t.attraction * Math.max(0.5, a)));
            N.multiplyScalar(t.friction);
            N.clampLength(0, t.maxVelocity);
            O.add(N);
            O.toArray(s, r);
            N.toArray(o, r);
        }
        for (let e = 1; e < t.count; e++) {
            const i = 3 * e;
            O.fromArray(s, i);
            N.fromArray(o, i);
            const r = n[e];
            for (let i = e + 1; i < t.count; i++) {
                const e = 3 * i;
                V.fromArray(s, e);
                j.fromArray(o, e);
                const t = n[i];
                _.copy(V).sub(O);
                const a = _.length();
                const c = r + t;
                if (a < c) {
                    const t = c - a;
                    W.copy(_).normalize().multiplyScalar(0.5 * t);
                    H.copy(W).multiplyScalar(Math.max(N.length(), 1));
                    T.copy(W).multiplyScalar(Math.max(j.length(), 1));
                    O.sub(W);
                    N.sub(H);
                    V.add(W);
                    j.add(T);
                    V.toArray(s, e);
                    j.toArray(o, e);
                }
            }
            _.copy(F).sub(O);
            const a = _.length();
            const c = r + n[0];
            if (a < c) {
                const e = c - a;
                W.copy(_).normalize().multiplyScalar(e);
                H.copy(W).multiplyScalar(Math.max(N.length(), 2));
                O.sub(W);
                N.sub(H);
            }
            O.toArray(s, i);
            N.toArray(o, i);
        }
    }
}

class U extends THREE.MeshPhysicalMaterial {
    constructor(e) {
        super(e);
        this.uniforms = {
            thicknessDistortion: { value: 0.1 },
            thicknessAmbient: { value: 0 },
            thicknessAttenuation: { value: 0.1 },
            thicknessPower: { value: 2 },
            thicknessScale: { value: 10 }
        };
        this.defines.USE_UV = "";
        this.onBeforeCompile = (e) => {
            Object.assign(e.uniforms, this.uniforms);
            e.fragmentShader = `
                uniform float thicknessPower;
                uniform float thicknessScale;
                uniform float thicknessDistortion;
                uniform float thicknessAmbient;
                uniform float thicknessAttenuation;
                uniform vec3 thicknessColor;
            ` + e.fragmentShader;
            e.fragmentShader = e.fragmentShader.replace("void main() {", `
                void RE_Direct_Scattering(const in IncidentLight directLight, const in vec2 uv, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, inout ReflectedLight reflectedLight) {
                    vec3 scatteringHalf = normalize(directLight.direction + (geometryNormal * thicknessDistortion));
                    float scatteringDot = pow(saturate(dot(geometryViewDir, -scatteringHalf)), thicknessPower) * thicknessScale;
                    vec3 scatteringIllu = (scatteringDot + thicknessAmbient) * vColor;
                    reflectedLight.directDiffuse += scatteringIllu * thicknessAttenuation * directLight.color;
                }

                void main() {
            `);
            const t = THREE.ShaderChunk.lights_fragment_begin.replaceAll("RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );", `
                RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
                RE_Direct_Scattering(directLight, vUv, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, reflectedLight);
            `);
            e.fragmentShader = e.fragmentShader.replace("#include <lights_fragment_begin>", t);
        };
    }
}

const X = {
    count: 100,
    colors: [16711680, 0, 16777215],
    pointLightIntensity: 150,
    directionalLightColor: 16777215,
    directionalLightIntensity: 5,
    materialParams: {
        metalness: 0.5,
        roughness: 0.5,
        clearcoat: 1,
        clearcoatRoughness: 0.15
    },
    minSize: 0.25,
    maxSize: 1,
    size0: 3,
    attraction: 0.15,
    friction: 0.999,
    maxVelocity: 0.15
};
const Y = new THREE.Object3D();

class q extends THREE.InstancedMesh {
    constructor(e, t = {}) {
        const i = { ...X, ...t };
        super(new THREE.SphereGeometry(1, 16, 12), new U(i.materialParams), i.count);
        this.castShadow = true;
        this.receiveShadow = true;
        this.config = i;
        this.physics = new B(i);
        this.initLights();
        this.setColors(i.colors);
    }
    initLights() {
        this.pointLight = new THREE.PointLight(this.config.colors[0], this.config.pointLightIntensity);
        this.add(this.pointLight);
        const e = this.directionalLight = new THREE.DirectionalLight(this.config.directionalLightColor, this.config.directionalLightIntensity);
        e.position.set(20, 20, 20);
        e.target.position.set(0, 0, 0);
        e.castShadow = true;
        e.shadow.mapSize.width = 1024;
        e.shadow.mapSize.height = 1024;
        e.shadow.camera.far = 50;
        e.shadow.camera.left = -17.5;
        e.shadow.camera.right = 17.5;
        e.shadow.camera.top = 17.5;
        e.shadow.camera.bottom = -17.5;
        this.add(e);
        this.add(e.target);
    }
    setColors(e) {
        if (Array.isArray(e) && e.length > 1) {
            const t = function (e) {
                let t, i;
                function s(e) {
                    t = e;
                    i = [];
                    t.forEach((e) => {
                        const t = new THREE.Color(e);
                        i.push(t);
                    });
                }
                s(e);
                return {
                    setColors: s,
                    getColorAt: function (e, s = new THREE.Color()) {
                        const n = Math.max(0, Math.min(1, e)) * (t.length - 1);
                        const o = Math.floor(n);
                        const r = i[o];
                        if (o >= t.length - 1) {
                            return r.clone();
                        }
                        const a = n - o;
                        const c = i[o + 1];
                        s.r = r.r + a * (c.r - r.r);
                        s.g = r.g + a * (c.g - r.g);
                        s.b = r.b + a * (c.b - r.b);
                        return s;
                    }
                };
            }(e);
            for (let e = 0; e < this.count; e++) {
                this.setColorAt(e, t.getColorAt(e / this.count));
                if (e === 0) {
                    this.pointLight.color.copy(t.getColorAt(e / this.count));
                }
            }
            this.instanceColor.needsUpdate = true;
        }
    }
    update(e) {
        this.physics.update(e);
        for (let e = 0; e < this.count; e++) {
            Y.position.fromArray(this.physics.positionData, 3 * e);
            Y.scale.setScalar(this.physics.sizeData[e]);
            Y.updateMatrix();
            this.setMatrixAt(e, Y.matrix);
            if (e === 0) {
                this.pointLight.position.copy(Y.position);
            }
        }
        this.instanceMatrix.needsUpdate = true;
    }
}

function G(e, t) {
    const i = new b({
        canvas: e,
        size: "parent",
        rendererOptions: {
            antialias: false,
            powerPreference: "low-power",
            alpha: true
        }
    });
    i.cameraMaxAspect = 1.5;
    i.camera.position.set(0, 0, 30);
    i.camera.lookAt(0, 0, 0);
    i.updateWorldSize();
    i.renderer.shadowMap.enabled = true;
    i.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    i.renderer.toneMapping = THREE.ACESFilmicToneMapping;

    const s = new RoomEnvironment();
    const n = new THREE.PMREMGenerator(i.renderer, 0.04).fromScene(s).texture;

    let o;
    function d(e) {
        if (o) {
            i.clear();
            i.scene.remove(o);
        }
        o = new q(i.renderer, e);
        const t = e.materialParams || {};
        if (typeof t.envMap === 'undefined') {
            o.material.envMap = n;
        }
        if (typeof t.envMapIntensity === 'undefined') {
            o.material.envMapIntensity = 0.25;
        }
        o.material.envMapRotation.x = -Math.PI / 2;
        i.scene.add(o);
    }

    const r = new THREE.Raycaster();
    const c = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
    const h = new THREE.Vector3();
    let l = false;

    const m = M({
        domElement: e,
        onMove() {
            r.setFromCamera(m.nPosition, i.camera);
            i.camera.getWorldDirection(c.normal);
            r.ray.intersectPlane(c, h);
            if (o) {
                o.physics.center.copy(h);
            }
        },
        onLeave() {
            if (o) {
                if (e.leaveX!== undefined && e.leaveY!== undefined) {
                    // 根据离开的位置更新o.physics.center
                    const rect = e.domElement.getBoundingClientRect();
                    const x = e.leaveX - rect.left;
                    const y = e.leaveY - rect.top;
                    r.setFromCamera(new THREE.Vector2(x / rect.width * 2 - 1, -y / rect.height * 2 + 1), i.camera);
                    i.camera.getWorldDirection(c.normal);
                    r.ray.intersectPlane(c, h);
                    o.physics.center.copy(h);
                } else {
                    // 保持当前位置
                    o.physics.center.copy(o.physics.center);
                }
            }
        }
    });

    // 调用 d 函数确保 o 被初始化
    d(t);

    i.onBeforeRender = (e) => {
        if (o && !l) {
            o.update(e);
        }
    };
    i.onAfterResize = (e) => {
        if (o) {
            o.config.maxX = e.wWidth / 2;
            o.config.maxY = e.wHeight / 2;
        }
    };

    return {
        three: i,
        get spheres() {
            return o;
        },
        setCount(e) {
            d({ ...o.config, count: e });
        },
        togglePause() {
            l = !l;
        },
        dispose() {
            i.dispose();
        }
    };
}

export { G as default };
